function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.56 17.56"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.78 10.19l7.07 7.07a1 1 0 101.41-1.41l-7.07-7.07 7.07-7.07A1 1 0 1015.85.29L8.78 7.36 1.71.29A1 1 0 10.29 1.71l7.07 7.07-7.07 7.07a1 1 0 001.41 1.41z"
})));